import { ChangeDetectionStrategy, Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';

import { GasInputBoolean } from '@cikrf/gas-utils/decorators';

import { GasForm } from '../../gas-form.namespace';

@Component({
  selector: 'gas-switch-control',
  templateUrl: './gas-switch-control.component.html',
  styleUrls: ['./gas-switch-control.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasSwitchControlComponent {
  @GasInputBoolean()
  @HostBinding('class._on')
  @Input()
  public value: string | boolean = false;

  @GasInputBoolean()
  @Input()
  public isDisabled: string | boolean;

  @GasInputBoolean()
  @HostBinding('class._error')
  @Input()
  public isError: string | boolean = false;

  @Input()
  public state: GasForm.InputState | string = GasForm.InputState.Default;

  /** @deprecated */
  @Input()
  public enabledText: string;

  /** @deprecated */
  @Input()
  public disabledText: string;

  @HostBinding('class._primary')
  public get isPrimarySwitch(): boolean {
    return this.state === GasForm.InputState.Primary;
  }

  @HostBinding('class._success')
  public get isSuccessSwitch(): boolean {
    return this.state === GasForm.InputState.Success;
  }

  @HostBinding('class._disabled')
  public get isDisabledSwitch(): boolean {
    return this.isDisabled as boolean;
  }

  @Output('onSwitchChange')
  public onSwitchChange$: EventEmitter<boolean> = new EventEmitter(this.value as boolean);

  public toggleSwitch(): void {
    if (this.isDisabled) {
      return;
    }

    this.value = !this.value;
    this.onSwitchChange$.emit(this.value);
  }

  public getCheckedValue(): string {
    const text = this.enabledText ?
      this.enabledText :
      'Включено';

    return text;
  }

  public getNoCheckedValue(): string {
    const text = this.disabledText ?
      this.disabledText :
      'Выключено';

    return text;
  }

}
